<h3 mat-dialog-title>Download Validation Report as Csv</h3>

<div mat-dialog-actions>
    <button mat-raised-button mat-button color="primary" [mat-dialog-close]="data" (click)="confirm()">Download</button>
    <button mat-raised-button mat-button color="primary" (click)="onNoClick()">Cancel</button>
</div>